/**
 * An incident's timeline, as Archi sends it in a fenced ```archi-timeline
 * block. Built by code on the Archi service (customer-api-docs
 * `apps/archi/src/timeline.ts`) from the incident's alarms; the two shapes
 * must stay in step.
 */
export type EntryTone = "down" | "up" | "warning" | "info";

export interface TimelineEntry {
  at: string;
  title: string;
  detail?: string;
  tone: EntryTone;
  service?: string;
}

export interface TimelineSpec {
  title: string;
  status: "active" | "resolved";
  startedAt: string;
  resolvedAt: string | null;
  durationSeconds: number | null;
  services: { id: string; name: string | null }[];
  entries: TimelineEntry[];
  duringMaintenance: boolean;
}

export function parseTimeline(raw: string): TimelineSpec | null {
  try {
    const spec = JSON.parse(raw.trim()) as TimelineSpec;
    return Array.isArray(spec.entries) && typeof spec.title === "string"
      ? spec
      : null;
  } catch {
    return null;
  }
}
